import { fromJS } from 'immutable';
import { PARAGRAPH_GET_LOADED } from '../../../actions/Entity/Paragraph';
var initialState = fromJS({});
export default function paragraph() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case PARAGRAPH_GET_LOADED:
      {
        return state.set(action.paragraph_id, fromJS(action.data));
      }
    default:
      return state;
  }
}